<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-tag"></i> Cupom de Desconto
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                      @change="listEstados()"
                                  ></select-api>
                              </div>

                              <div class="col-md-4 col-xs-12">
                                  <label>Estado*</label>
                                  <dw-select
                                      :options="estados"
                                      v-model="model.id_estado"
                                      opt-text="nome"
                                      placeholder="Selecione um estado"
                                  >
                                      <option value="0" selected>Selecione um estado</option>
                                  </dw-select>
                              </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-3"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>

                                <div class="col-md-3">
                                    <label>Código</label>
                                    <input
                                        type="text"
                                        maxlength="50"
                                        class="form-control"
                                        v-model="model.codigo"
                                    />
                                </div>

                                <div
                                    class="col-md-3"
                                    :class="{ 'dropdown-has-error': $v.model.categoria.$error }"
                                    >
                                  <label>Categoria*</label>
                                  <Select2
                                      placeholder="Selecione"
                                      v-model="model.categoria"
                                      :options="categoriaDesconto"
                                  >
                                      <option value selected>Selecione</option>
                                  </Select2>
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Ativo</label>
                                    <br />
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-3 col-xs-12" :class="{ 'has-danger': $v.model.inicio.$error }">
                                    <label>Início*</label>
                                    <input-datepicker :autoclose="true" v-model="model.inicio" @input="$v.model.inicio.$touch()"></input-datepicker>
                                </div>
                                <div class="col-md-3 col-xs-12" :class="{ 'has-danger': $v.model.termino.$error }">
                                    <label>Término*</label>
                                    <input-datepicker :autoclose="true" v-model="model.termino" @input="$v.model.termino.$touch()"></input-datepicker>
                                </div>
                            </div>

                            <div class="form-group row">
                              <div
                                  class="col-md-3"
                                  :class="{ 'dropdown-has-error': $v.model.tipoDesconto.$error }"
                                  >
                                <label>Tipo Desconto*</label>
                                <Select2
                                    placeholder="Selecione"
                                    v-model="model.tipoDesconto"
                                    :options="tiposDesconto"
                                >
                                    <option value selected>Selecione</option>
                                </Select2>
                              </div>

                              <div class="col-md-3 col-xs-12"
                                  :class="{ 'has-danger': $v.model.valor.$error }">
                                  <label>Valor*</label>
                                  <money :prefix="''" v-model.trim="model.valor" class="form-control" />
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                  <label>Resumo</label>
                                  <dw-textarea
                                      maxlength="500"
                                      v-model="model.resumo"
                                  ></dw-textarea>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Descrição</label>
                                <dw-textarea
                                    maxlength="3000"
                                    v-model="model.descricao"
                                ></dw-textarea>
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                  <label>Contato</label>
                                  <input
                                      type="text"
                                      maxlength="150"
                                      class="form-control"
                                      v-model="model.contato"
                                  />
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Endereço</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.endereco"
                                ></dw-textarea>
                              </div>
                            </div>

                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Imagem'"
                                        :arquivo="model.arquivo"
                                    ></file-image>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-discount' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
        FileImage, Select2, SelectApi
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                codigo: "",
                inicio: moment().format("YYYY-MM-DD"),
                termino: moment().format("YYYY-MM-DD"),
                tipoDesconto: '',
                valor: '',
                categoria: '',
                resumo: '',
                descricao: '',
                contato: '',
                endereco: '',
                ativo: false,
                arquivo: null,
                id_pais: ''
            },
            imagem: null,
            tiposDesconto: Collections.tiposDesconto,
            categoriaDesconto: Collections.categoriaDesconto,
            estados: []
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                inicio: { required },
                termino: { required },
                tipoDesconto: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                valor: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                categoria: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                id_pais: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    watch: {
      // 'model.id_pais': function () {
      //     console.log(this.model.id_pais);
      //     this.listEstados();
      // }
    },
    methods: {
        async listEstados() {
            let vm = this;
            vm.estados = [];
            // vm.model.id_cidade = 0;
            this.$loading.show(true);

            let params = { params: { id_pais: vm.model.id_pais } };
            try {
                let ret = await facade.listState(params);
                vm.estados = ret.data.data;

                this.$loading.show(false);
            } catch(e) {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as cidades."
                );
                this.$loading.show(false);
            }
        },
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.imagem);

                if (vm.model.id) {
                    await facade.updateDiscount(formData, vm.model.id);
                    this.$router.push({ name: "list-discount" });
                } else {
                    await facade.createDiscount(formData);
                    this.$router.push({ name: "list-discount" });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
                vm.corObjeto = vm.model.cor;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let discount = null;

        if (to.params.id) {
            discount = (await facade.getDiscount(to.params.id)).data.data;
        }

        next(vm => vm.setData(discount));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?747e0308